<template>
  <modal-full class="c-modal--play-game" v-bind="$attrs" @close="handleBack('/games')" data-test="modalPlayGame">
    <template slot="headerActionSecondary">
      <router-link to="/">
        <svg class="c-logo c-logo--casino c-logo--casino-inverted c-logo--casino-sm "><use xlink:href="#logo-casino-inverted"></use></svg>
      </router-link>
    </template>
    
    <games-play :slug="slug"></games-play>
  </modal-full>
</template>

<script>
  // Components
  import ModalFull from '@/plugins/modals/ModalFull.vue';

  // Mixins
  import HandleBack from '@/mixins/HandleBack';

  export default {   
    name: 'ModalPlayGame',
    
    components: {
      ModalFull,
      GamesPlay: () => import(/* webpackChunkName: "GamesPlay" */'@/pages/GamesPlay.vue')
    },

    mixins: [
      HandleBack
    ],

    props: {
      slug: {
        type: String,
        required: true
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/components/ModalPlayGame.vue